import React, { Component } from "react";

import { Flex, Box } from "reflexbox";
import { observer, inject } from "mobx-react";

@inject("translationsStore")
@observer
export default class RegistrationsHeader extends Component {
  render() {
    const t = this.props.translationsStore.current;
    return (
      <Flex className="RegistrationsHeader">
        <Box auto w={1 / 6}>
          {t["shared"]["lblDate"]}
        </Box>
        <Box auto w={1 / 6}>
          {t["shared"]["lblName"]}
        </Box>
        <Box auto w={1 / 6}>
          {t["shared"]["lblImei"]}
        </Box>
        <Box auto w={1 / 6}>
          {t["shared"]["lblPlate"]}
        </Box>
        <Box auto w={1 / 6}>
          {t["shared"]["lblSubscriptionStatus"]}
        </Box>
        <Box auto w={1 / 6}>
          {t["shared"]["btnDelete"]}
        </Box>
      </Flex>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Registrations/RegistrationsHeader.js